import React from 'react';
import { Container } from '@mui/material';
import { Box } from '../../../design-system';
import { colors } from '../../../design-system/colors';
import FooterLogo from './FooterLogo';
import FooterNavLinks from './FooterNavLinks';
import FooterSocial from './FooterSocial';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: colors.background[850],
        borderTop: `1px solid ${colors.neutral.white}1A`,
        py: { xs: '3rem', md: '4rem' },
        minHeight: { xs: '120px', md: '140px' },
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'center', md: 'flex-start' },
            gap: { xs: 4, md: 0 },
          }}
        >
          <FooterLogo />
          <FooterNavLinks />
          <FooterSocial />
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
